<template>
  <div>
    <lk-table v-if="type==8" :key="8" :columns="recallColumns" :data="handledData"  border></lk-table>
    <lk-table v-if="type==7" :key="7" :columns="purchaseRefundColumns" :data="handledData"  border></lk-table>
    <lk-table v-if="type==6" :key="6" :columns="paymentColumns" :data="handledData"  border></lk-table>
    <lk-table v-if="type==5" :key="5" :columns="payableColumns" :data="handledData" border></lk-table>
    <!-- <lk-table v-if="type==" :columns="proceedColumns" :data="data"></lk-table> -->
    <lk-table v-if="type==4" :key="4" :columns="inspectionColumns" :data="handledData" border></lk-table>
    <lk-table v-if="type==3" :key="3" :columns="purchaseReceiptColumns" :data="handledData" border></lk-table>
    <lk-table v-if="type==2" :key="2" :columns="purchaseOrderColumns" :data="handledData" border></lk-table>
    <lk-table v-if="type==1" :key="1" :columns="purchasePlanColumns" :data="handledData" border></lk-table>
  </div>
</template>
<script>
// import finance from '../services/finance';
import utils from '../libs/utils';
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-loop-func */
export default {
  name: 'chartTable',
  props: {
    data: {
      type: Array,
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    type() {

    },
  },
  computed: {
    handledData() {
      const result = utils.deepClone(this.data);
      result.forEach((item) => {
        for (const key in item) {
          switch (key) {
            case 'createTime':
              item[key] = utils.exchangeTime(item[key]);
              break;
            default:
              break;
          }
        }
        const financePayableCreateType = item.financePayableCreateType;
        if (financePayableCreateType && financePayableCreateType === 2) {
          item.amount = item.totalSetOffAmount;
        }
        // if (this.type === 2) {
        item.totalAmount = 0;
        // if (item.amount) {
        //   item.amount = utils.exchangePercent(item.amount);
        // }
        // }
        if (item.subList) {
          item.subList.forEach((subItem, index) => {
            // console.log(subItem);
            subItem.index = index + 1;
            switch (this.type) {
              case 1:
                item.totalAmount += subItem.purchaseMedicineAmount;
                break;
              case 2:
                item.totalAmount += subItem.purchaseMedicineAmount;
                break;
              case 3:
                item.totalAmount += (subItem.purchaseReceiptInfoAcceptNum * subItem.purchaseReceiptInfoPriceBeforeTax);
                break;
              case 4:
                item.totalAmount += subItem.inspectionInfoAmount;
                break;
              default:
                break;
            }

            for (const subKey in subItem) {
              switch (subKey) {
                case 'createTime':
                  subItem[subKey] = utils.exchangeTime(subItem[subKey]);
                  break;

                // case 'inspectionInfoTotalTax':
                //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                //   break;
                // case 'purchaseReceiptInfoPriceBeforeTax':
                //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                //   break;
                // case 'purchaseReceiptInfoTax':
                //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                //   break;
                // case 'inspectionInfoAmount':
                //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                //   break;
                case 'purchaseReceiptInfoTaxRate':
                  subItem[subKey] += '%';
                  break;
                case 'taxRate':
                  subItem[subKey] += '%';
                  break;
                case 'realInputTaxRate':
                  subItem[subKey] += '%';
                  break;
                case 'purchaseInspectionInfoTaxRate':
                  subItem[subKey] += '%';
                  break;
                case 'inputTaxRate':
                  subItem[subKey] += '%';
                  break;
                  // case 'purchaseMedicinePlanPrice':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'purchaseMedicineAmount':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'priceBeforeTax':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'priceAfterTax':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'tax':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'totalPriceBeforeTax':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'totalTax':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'purchaseReceiptInfoTotalAmountWithoutTax':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'purchaseReceiptInfoTotalPriceBeforeTax':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'purchaseReceiptInfoMedicineTax':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'purchaseReceiptInfoPriceAfterTax':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'inspectionInfoAmount':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  //   // subItem[subKey] += '%';
                  //   break;
                  // case 'orderAmount':
                  //   subItem[subKey] = utils.exchangePercent(subItem[subKey]);
                  // subItem[subKey] += '%';
                  // break;
                default:
                  break;
              }
            }
          });
        }
        item.totalAmount = item.totalAmount.toFixed(2);
      });
      return result;
    },
  },
  data() {
    return {
      typeList: [
        'payable', // 应付单
        'payment', // 付款单
        // 'Proceed', // 应收单
        'inspection', // 验收
        'receipt', // 收货
        'order', // 采购订单
        'plan', // 采购计划
      ],
      recallColumns: [
        {
          type: 'expand',
          width: 116,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.recallSubColumns,
              data: params.row.subList,
            },
          }),
        },
        {
          title: '召回单号',
          key: 'recallPlanCode',
          minWidth: 116,
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 116,
        },
        {
          title: '召回机构',
          key: 'recallAgency',
          minWidth: 116,
          render: this.renderExistGood,
        },
        {
          title: '召回时间',
          key: 'createTime',
          minWidth: 116,
          render: this.renderExistGood,
        },
        {
          title: '总金额',
          key: 'totalAmount',
          minWidth: 116,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 116,
        },
        {
          title: '状态',
          key: 'recallPlanStatusName',
          minWidth: 116,
        },
      ],
      recallSubColumns: [
        {
          title: '行号', key: 'index', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '商品通用名', key: 'financePayableInfoApprovedDrugName', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '规格', key: 'financePayableInfoSpecification', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '生产企业', key: 'financePayableInfoManufacturer', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认单价', key: 'financePayableInfoRealPriceWithTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '数量', key: 'financePayableInfoNum', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认税率', key: 'financePayableInfoRealInputTaxRate', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认不含税单价', key: 'financePayableInfoPriceAfterTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认单个税额', key: 'financePayableInfoRealTax', minWidth: 126, render: this.renderExistGood,
        },
        {
          title: '确认含税总金额', key: 'financePayableInfoRealTotalPriceBeforeTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认总税额', key: 'financePayableInfoRealTotalTax', minWidth: 136, render: this.renderExistGood,
        },
      ],
      purchaseRefundColumns: [
        {
          type: 'expand',
          width: 116,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.purchaseRefundSubColumns,
              data: params.row.subList,
            },
          }),
        },
        {
          title: '退货单号',
          key: 'code',
          minWidth: 116,
        },
        {
          title: '退货总金额',
          key: 'amount',
          minWidth: 116,
        },
        {
          title: '供应商名称',
          key: 'supplierName',
          minWidth: 116,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 116,
        },
        {
          title: '状态',
          key: 'statusName',
          minWidth: 116,
        },
      ],
      purchaseRefundSubColumns: [
        {
          title: '行号', key: 'index', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '商品通用名', key: 'purchaseRefundDetailApprovedName', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '规格', key: 'purchaseRefundDetailSpec', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '退货数量', key: 'purchaseRefundDetailNum', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '退货单价', key: 'purchaseRefundDetailRefundPrice', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '退货总金额', key: 'purchaseRefundDetailAmount', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '验收单号', key: 'purchaseRefundDetailInspectionCode', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '原验收数量', key: 'purchaseRefundDetailInspectionPassNum', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '验收单价', key: 'purchaseRefundDetailPriceWithTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确定税率', key: 'purchaseRefundDetailInputTaxRate', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认不含税单价', key: 'purchaseRefundDetailRefundPriceAfterTax', minWidth: 126, render: this.renderExistGood,
        },
        {
          title: '确认单个税额', key: 'purchaseRefundDetailRefundTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认不含税总金额', key: 'purchaseRefundDetailRefundTotalPriceAfterTax', minWidth: 136, render: this.renderExistGood,
        },
        {
          title: '确认总税金', key: 'purchaseRefundDetailRefundTotalTax', minWidth: 116, render: this.renderExistGood,
        },
      ],
      payableColumns: [
      // {title: '序号', key: 'index', minWidth: 116,},
        {
          type: 'expand',
          width: 116,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.payableSubColumns,
              data: params.row.subList,
            },
          }),
        },
        { title: '应付单号', key: 'code', minWidth: 116 },
        { title: '应付金额', key: 'amount', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '状态', key: 'statusName', minWidth: 116 },
      ],
      payableSubColumns: [
        {
          title: '来源单据', key: 'financePayableInfoReferCode', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '商品通用名',
          key: 'financePayableInfoApprovedDrugName',
          minWidth: 116,
          render: this.renderExistGood,
        },
        {
          title: '规格', key: 'financePayableInfoSpecification', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '生产企业', key: 'financePayableInfoManufacturer', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '单价', key: 'financePayableInfoPriceBeforeTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认进价', key: 'financePayableInfoRealPriceWithTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认税率', key: 'financePayableInfoRealInputTaxRate', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认不含税单价', key: 'financePayableInfoRealPriceAfterTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认单个税额', key: 'financePayableInfoRealTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认不含税总金额', key: 'financePayableInfoRealTotalPriceAfterTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认总税金', key: 'financePayableInfoRealTotalTax', minWidth: 116, render: this.renderExistGood,
        },
      ],
      paymentColumns: [
        {
          type: 'expand',
          width: 116,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.PaymentSubColumns,
              data: params.row.subList,
            },
          }),
        },
        { title: '付款单号', key: 'code', minWidth: 116 },
        { title: '付款金额', key: 'amount', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '状态', key: 'statusName', minWidth: 116 },
      ],
      PaymentSubColumns: [
        {
          title: '应付单号',
          key: 'financePayableInfoPayableCode',
          minWidth: 116,
          render: this.renderExistGood,
        },
        {
          title: '商品通用名',
          key: 'financePayableInfoApprovedDrugName',
          minWidth: 116,
          render: this.renderExistGood,
        },
        {
          title: '规格', key: 'financePayableInfoSpecification', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '生产企业', key: 'financePayableInfoManufacturer', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认单价', key: 'financePayableInfoRealPriceWithTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认税率', key: 'financePayableInfoRealInputTaxRate', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认不含税单价', key: 'financePayableInfoRealPriceAfterTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认单个税额', key: 'financePayableInfoRealTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认不含税总金额', key: 'financePayableInfoRealTotalPriceAfterTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认总税金', key: 'financePayableInfoRealTotalTax', minWidth: 116, render: this.renderExistGood,
        },
      ],
      ProceedColumns: [
      // {title: '序号', key: 'index', minWidth: 116,},
        {
          type: 'expand',
          width: 116,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.ProceedSubColumns,
              data: params.row.subList,
            },
          }),
        },
        { title: '应收单号', key: 'name', minWidth: 116 },
        { title: '应收金额', key: 'name', minWidth: 116 },
        { title: '创建人', key: 'name', minWidth: 116 },
        { title: '创建时间', key: 'name', minWidth: 116 },
        { title: '状态', key: 'name', minWidth: 116 },
      ],
      ProceedSubColumns: [
        { title: '验收单号', key: 'index', minWidth: 116 },
        { title: '规格', key: 'name', minWidth: 116 },
        { title: '生产企业', key: 'name', minWidth: 116 },
        { title: '单价', key: 'name', minWidth: 116 },
        { title: '税率', key: 'name', minWidth: 116 },
        { title: '不含税单价', key: 'name', minWidth: 116 },
        { title: '单个税额', key: 'name', minWidth: 116 },
        { title: '含税总金额', key: 'inspectionInfoAmount', minWidth: 116 },
        { title: '总税额', key: 'name', minWidth: 116 },
      ],
      inspectionColumns: [
      // {title: '序号', key: 'index', minWidth: 116,},
        {
          type: 'expand',
          width: 116,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.inspectionSubColumns,
              data: params.row.subList,
            },
          }),
        },
        { title: '验收单号', key: 'code', minWidth: 116 },
        // { title: '收货单号', key: 'name', minWidth: 116 },
        // { title: '采购订单号', key: 'name', minWidth: 116 },
        // { title: '采购计划号', key: 'name', minWidth: 116 },
        { title: '成本类型', key: 'paymentName', minWidth: 116 },
        { title: '总金额', key: 'totalAmount', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '状态', key: 'statusName', minWidth: 116 },
      ],
      inspectionSubColumns: [
        {
          title: '行号', key: 'index', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '商品通用名',
          key: 'purchaseMedicineApprovedDrugName',
          minWidth: 116,
          render: this.renderExistGood,
        },
        {
          title: '规格', key: 'purchaseMedicineSpecification', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '验收数量', key: 'purchaseInspectionInfoPassNum', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认单价', key: 'purchaseInspectionInfoPriceBeforeTax', minWidth: 116, render: this.renderExistGood,
        },
        // { title: '收货数量', key: 'purchaseReceiptInfoAcceptNum', minWidth: 116 },
        // { title: '实际单价', key: 'name', minWidth: 116 },
        // { title: '生产企业', key: 'name', minWidth: 116 },
        // { title: '单价', key: 'name', minWidth: 116 },
        // {
        //   title: '税率', key: 'purchaseInspectionInfoTaxRate', minWidth: 116, render: this.renderExistGood,
        // },
        // {
        //   title: '不含税单价', key: 'purchaseInspectionInfoPriceAfterTax', minWidth: 116, render: this.renderExistGood,
        // },
        // {
        //   title: '单个税额', key: 'purchaseInspectionInfoTax', minWidth: 116, render: this.renderExistGood,
        // },
        // {
        //   title: '含税总金额', key: 'inspectionInfoAmount', minWidth: 116, render: this.renderExistGood,
        // },
        // {
        //   title: '总不含税金额', key: 'purchaseInspectionInfoTotalPriceAfterTax', minWidth: 116, render: this.renderExistGood,
        // },
        // {
        //   title: '税额', key: 'purchaseInspectionInfoTotalTax', minWidth: 116, render: this.renderExistGood,
        // },
        {
          title: '确认税率', key: 'purchaseInspectionInfoTaxRate', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认不含税单价', key: 'purchaseInspectionInfoPriceAfterTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认单个税额', key: 'purchaseInspectionInfoTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认不含税总金额', key: 'purchaseInspectionInfoTotalPriceAfterTax', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '确认总税金', key: 'purchaseInspectionInfoTotalTax', minWidth: 116, render: this.renderExistGood,
        },
      ],
      purchaseReceiptColumns: [
      // {title: '序号', key: 'index', minWidth: 116,},
        {
          type: 'expand',
          width: 116,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.purchaseReceiptSubColumns,
              data: params.row.subList,
            },
          }),
        },
        { title: '收货单号', key: 'code', minWidth: 116 },
        // { title: '采购订单号', key: 'name', minWidth: 116 },
        // { title: '采购计划号', key: 'name', minWidth: 116 },
        { title: '成本类型', key: 'paymentName', minWidth: 116 },
        { title: '总金额', key: 'totalAmount', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '状态', key: 'statusName', minWidth: 116 },
        // { title: '状态', key: 'statusName', minWidth: 116 },
      ],
      purchaseReceiptSubColumns: [
        {
          title: '行号', key: 'index', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '商品通用名',
          key: 'purchaseMedicineApprovedDrugName',
          minWidth: 116,
          render: this.renderExistGood,
        },
        {
          title: '规格', key: 'purchaseMedicineSpecification', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '采购数量', key: 'purchaseMedicineNum', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '计划单价', key: 'purchaseMedicinePlanPrice', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '收货数量', key: 'purchaseReceiptInfoAcceptNum', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '实际单价', key: 'purchaseReceiptInfoPriceBeforeTax', minWidth: 116, render: this.renderExistGood,
        },
        // { title: '生产企业', key: 'name', minWidth: 116 },
        // { title: '单价', key: 'name', minWidth: 116 },
        {
          title: '税率', key: 'purchaseReceiptInfoTaxRate', minWidth: 116, render: this.renderExistGood,
        },
        // { title: '确认税率', key: 'purchaseReceiptInfoTaxRate', minWidth: 116 },
        // { title: '不含税单价', key: 'name', minWidth: 116 },
        // { title: '单个税额', key: 'name', minWidth: 116 },
        {
          title: '含税总金额', key: 'purchaseReceiptInfoTotalPriceBeforeTax', minWidth: 116, render: this.renderExistGood,
        },
      ],
      purchaseOrderColumns: [
      // {title: '序号', key: 'index', minWidth: 116,},
        {
          type: 'expand',
          width: 116,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.purchaseOrderSubColumns,
              data: params.row.subList,
            },
          }),
        },
        { title: '采购订单号', key: 'code', minWidth: 116 },
        // { title: '采购计划号', key: 'name', minWidth: 116 },
        { title: '成本类型', key: 'paymentName', minWidth: 116 },
        // { title: '订单金额', key: 'accountPayable', minWidth: 116 },
        { title: '订单金额', key: 'totalAmount', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '状态', key: 'statusName', minWidth: 116 },
      ],
      purchaseOrderSubColumns: [
        {
          title: '行号', key: 'index', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '商品通用名',
          key: 'purchaseMedicineApprovedDrugName',
          minWidth: 116,
          render: this.renderExistGood,
        },
        {
          title: '规格', key: 'purchaseMedicineSpecification', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '采购数量', key: 'purchaseMedicineNum', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '计划单价', key: 'purchaseMedicinePlanPrice', minWidth: 116, render: this.renderExistGood,
        },
        // { title: '不含税单价', key: 'name', minWidth: 116 },
        // { title: '单个税额', key: 'name', minWidth: 116 },
        // { title: '含税总金额', key: 'name', minWidth: 116 },
        // { title: '总税额', key: 'name', minWidth: 116 },
      ],
      purchasePlanColumns: [
      // {title: '序号', key: 'index', minWidth: 116,},
        {
          type: 'expand',
          width: 116,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.purchasePlanSubColumns,
              data: params.row.subList,
            },
          }),
        },
        { title: '计划单号', key: 'code', minWidth: 116 },
        { title: '计划金额', key: 'totalAmount', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '状态', key: 'statusName', minWidth: 116 },
      ],
      purchasePlanSubColumns: [
        {
          title: '行号', key: 'index', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '商品通用名',
          key: 'purchaseMedicineApprovedDrugName',
          minWidth: 116,
          render: this.renderExistGood,
        },
        {
          title: '规格', key: 'purchaseMedicineSpecification', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '计划数量', key: 'purchaseMedicineNum', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '计划单价', key: 'purchaseMedicinePlanPrice', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '总金额', key: 'purchaseMedicineAmount', minWidth: 116, render: this.renderExistGood,
        },
        {
          title: '成本类型', key: 'purchaseMedicinePaymentName', minWidth: 116, render: this.renderExistGood,
        },
        // { title: '不含税单价', key: 'name', minWidth: 116 },
        // { title: '单个税额', key: 'name', minWidth: 116 },
        // { title: '含税总金额', key: 'name', minWidth: 116 },
        // { title: '总税额', key: 'name', minWidth: 116 },
      ],
    };
  },
  methods: {
    renderExistGood(h, params) {
      return h('span', {
        class: {
          blue: params.row.isFromSourceItem === 1,
        },
      }, params.row[params.column.key]);
    },
    renderEqulRefund(h, params) {
      // 当前是退货单不做处理
      const routerId = Number(this.$route.params.id);
      return h('span', {
        class: {
          blue: params.row.id === routerId,
        },
      }, params.row[params.column.key]);
    },
    // getPayable(id) {
    //   finance.flowInfoPayable({ financePayableId: id }).then((res) => {
    //     if (res.data.status === 200) {

    //     } else {
    //       this.$Message.error(res.data.error);
    //     }
    //   }).catch((err) => {
    //     utils.handleError(err);
    //   });
    // },
  },
  mounted() {
    // this.getPayable(this.id)
  },
};
</script>
<style lang="less" scoped>

</style>
